import React from 'react';
import AppRouter from './router';
import { AuthProvider } from './components/authContext';
import './App.css'

const App = () => {
  return (
    <AuthProvider>
        <AppRouter />
    </AuthProvider>
  );
};

export default App;